import { styled, CarouselSlide } from '@hermes/web-components'

export const StyledSplideSlide = styled(CarouselSlide)`
  transition: opacity 0.5s ease-in-out;

  &.splide__slide.is-visible {
    opacity: 1;

    & > div {
      transform: scale(1);
      transition: transform 0.5s ease-in-out;
    }
  }

  &:not(.is-visible) {
    opacity: 0;

    & > div {
      transform: scale(0.8);
    }
  }
`
